import { ContentLayout } from 'components/Layouts'
// import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { DeleteAccountForm } from '../components/DeleteAccountForm/DeleteAccountForm'
import { Component } from '@cms-max/medicare-api-sdk'
import { CmsHeaderEventName } from '@cms-max/cms-browser-api-client'
import { LanguagePreference } from 'models/LanguagePreference'
import getSubdomain from 'utils/urls/getSubdomain'
import { medicareApiClient } from 'clients/medicareApiClient'

/**
 * Returns value to sso signout with callback uri (delete account success page)
 * @param lang
 * @returns string
 */
export const getDeleteAccountSuccessURL = (lang:LanguagePreference) => {
  const ignoredSubdomain = lang === 'es' ? 'www' : undefined
  const medicareSubdomain = getSubdomain(process.env.REACT_APP_MEDICARE_ENV || '', ignoredSubdomain)
  const langSubdomain = getSubdomain(lang, 'en')

  const redirectUri = `https://${langSubdomain + medicareSubdomain}medicare.gov/my/account-settings/delete-account-success`
  return `https://${langSubdomain + medicareSubdomain}medicare.gov/sso/signout?redirect_uri=${redirectUri}`
}

export const DeleteAccountPage = () => {
  const { t, i18n } = useTranslation('deleteAccount')
  // const [password, setPassword] = useState('')

  const formProps = {
    onSubmit: async () => {
      try {
        // call delete account on core
        await medicareApiClient.authenticationApi.deleteAccount()

        // dispatch document event to handle clearing all cookies
        document.dispatchEvent(new CustomEvent(CmsHeaderEventName.Logout))

        // redirect to sso signout with callback uri (delete account success page)
        window.location.assign(getDeleteAccountSuccessURL(i18n.language as LanguagePreference))
      } catch (error) {
        // TODO handle errors from core api based on design
      }
    }, // (password: string) => setPassword(password),
    href: '/account-settings'
  }

  return (
    <>
      <BreadCrumb
        backButtonText={t('navigation.backToSettingsText')}
        width='wide'
        navAriaLabel={t('navigation.backToSettingsNavAriaLabel')}
        backButtonLink='/home'
        siteActivityProps={{
          core: {
            component: Component.AccountSettings,
            elementId: 'ps_backtoaccounthome_click',
            coreClickData: {
              linkText: t('breadcrumb.back'),
              linkUrl: buildAbsoluteMedicareMyUrl('/home')
            }
          }
        }}
      />
      <ContentLayout
        heading={t('heading')}
        withPrintButton={false}
        width='wide'
      >
        <div className='ds-l-container'>
          <p>{t('content.noticeText')}</p>
          <ul>
            <li>{t('content.noticeBullet1')}</li>
            <li>{t('content.noticeBullet2')}</li>
            <li>{t('content.noticeBullet3')}</li>
          </ul>
          <p>{t('content.warningText')}</p>
          <DeleteAccountForm {...formProps} />
        </div>
      </ContentLayout>
    </>
  )
}
